import { MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact'
import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'

function PlayerSelectorModal({ selectedPlayer, setSelectedPlayer }) {
    const [players, setPlayers] = useState([])

    const [searchTerm, setSearchTerm] = useState('')
    const [filteredPlayers, setFilteredPlayers] = useState([])

    const [show, setShow] = useState(false)

    useEffect(() => {
        if (show) {
            try {
                const playersRef = firestore.collection('players-fb')
                playersRef.orderBy('player_name').onSnapshot(({ docs }) => {
                    const players = docs.map((doc) => {
                        return { id: doc.id, ...doc.data() }
                    })
                    setPlayers(players)
                    setFilteredPlayers(players)
                })
            } catch (error) {}
        }
    }, [show])

    useEffect(() => {
        if (players?.length > 0 && searchTerm && searchTerm?.trim() !== '') {
            const filteredPlayersSearch = players?.filter((player) =>
                player?.player_name?.toLowerCase().includes(searchTerm)
            )
            setFilteredPlayers(filteredPlayersSearch)
        } else {
            setFilteredPlayers(players)
        }
    }, [searchTerm, players])

    function toggleModal() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    function selectPlayerHandler(player) {
        if (player) {
            setSelectedPlayer(player)
            setShow(false)
        }
    }

    return (
        <React.Fragment>
            <div className="btn btn-success my-4" onClick={() => setShow(true)}>
                Velg spiller
            </div>

            <MDBModal size="xl" isOpen={show} toggle={toggleModal}>
                <MDBModalHeader toggle={toggleModal}>
                    Velg spiller
                </MDBModalHeader>
                <MDBModalBody>
                    <div>
                        <label>
                            <small>Søk spiller</small>
                        </label>
                        <input
                            className="form-control mb-2"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Søk spiller"
                        />
                    </div>

                    <div className="row">
                        {filteredPlayers?.map((player, index) => {
                            return (
                                <div
                                    className="col-6 col-md-4 col-xl-2 my-3"
                                    key={index}
                                >
                                    <img
                                        src={player.player_image}
                                        onClick={() =>
                                            selectPlayerHandler(player)
                                        }
                                        alt=""
                                        className="img-fluid player-image"
                                        style={
                                            player.id === selectedPlayer?.id
                                                ? {
                                                      border: '5px solid royalblue',
                                                  }
                                                : { border: 'none' }
                                        }
                                    />
                                    <br />
                                    <br />
                                    <figcaption>
                                        <p>
                                            <span className="font-weight-bold">
                                                Navn:
                                            </span>{' '}
                                            {player.player_name}
                                        </p>
                                        <p>
                                            <span className="font-weight-bold">
                                                Posisjon:
                                            </span>{' '}
                                            {player.position}
                                        </p>
                                        <p>ID: {player.id}</p>
                                    </figcaption>
                                </div>
                            )
                        })}
                    </div>
                </MDBModalBody>
            </MDBModal>
        </React.Fragment>
    )
}
export default PlayerSelectorModal
